export default from './no-member-results';



// WEBPACK FOOTER //
// ./app/components/no-member-results/index.js